import { createApp } from "vue";
import App from "./App.vue";

/* import messages from "@intlify/unplugin-vue-i18n/messages";
console.log(messages) */
/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router, { routerInit } from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import locale from "element-plus/lib/locale/lang/vi";
import i18n from "@/core/plugins/i18n";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

//imports for app initialization
//import MockAdapter from "@/core/mock/MockService";
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";

import '@/assets/css/custome.css';

const app = createApp(App);

app.use(store);
app.use(ElementPlus, { locale });

ApiService.init(app);
//MockAdapter.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);
/* for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
} */

(async () => {
  await store.commit('menuRouteLoaded', false);
  await routerInit(app);
})().then(() => {
  app.mount("#app");
});
// Check if running inside an iframe
if (window.top === window.self && window.location.pathname !== '/404' && window.location.pathname !== '/500' && window.location.pathname !== '/privacy-policy') { 
  // Not embedded in an iframe — block access
  window.location.href = '/404';
}

export default app
